<template>
    <div id="verifyPop" class="pop" v-show="verifyshow">
        <div class="content">
            <span class="close" @click="closePop('verifyshow')"></span>
            <div class="huakuai"></div>
        </div>
    </div>
</template>
<script>
import mixins from '../../mixins';
export default {
    name: 'MyVerify',
    mixins: [mixins],
    data() {
        return {
            verifyshow: false,
            verify: null
        }
    },
    methods: {
        refresh(callback) {
            this.verifyshow = true;
            if (this.verify) {
                this.verify.retry();
            } else {
                this.verify = new Verify('230109', '.huakuai', () => {
                    callback(this.verify.getCurrentKey())
                });
            }
        },
        hide() {
            this.verifyshow = false;
        }
    }
}
</script>

<style lang="scss" scoped>
#verifyPop {
    animation-duration: 0.4s;
    animation-fill-mode: both;
    animation-name: fadeIn;

    .content {
        background: none;
        transform: translate3d(-50%, -50%, 0);

        .close {
            top: auto;
            bottom: -1.2rem;
            right: 50%;
            margin-right: -0.55rem;
        }
    }
}
</style>